import React from 'react'
import _ from 'lodash'
import {
    selectCompareParts
} from '../table/compareSlice'
import {useSelector} from 'react-redux'
import ReactTooltip from "react-tooltip";

const CompareGo = ({part_id, hash}) => {
    const compareParts = useSelector(selectCompareParts)
    const isPartsInCompare = _.size(compareParts) > 0

    const compareOpen = (isPartsInCompare) => (e) => {
        if (isPartsInCompare) {
            window.open('/auto/search/compare/', '_blank')
        }
    }

    return (
        <>
            Сравнение:
            {isPartsInCompare ?
                (
                    <button

                        className={isPartsInCompare ? 'compare-go__icon' : 'compare-go__icon disbled'}
                        onClick={compareOpen(isPartsInCompare)}
                    >
                        <svg fill="#ffffff" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 30.016h20v-4h-20v4zM0 22.016h28v-4h-28v4zM0 14.016h24v-4h-24v4zM0 6.016h32v-4h-32v4z"></path>
                        </svg>
                    </button>
                )
                :
                (
                    <>
                        <button
                            className='compare-go__icon disbled'
                            data-for="tooltip_compare_go"
                            data-tip="custom"
                            data-event="click"
                        >
                            <svg fill="#ffffff" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 30.016h20v-4h-20v4zM0 22.016h28v-4h-28v4zM0 14.016h24v-4h-24v4zM0 6.016h32v-4h-32v4z"></path>
                            </svg>
                        </button>
                        <ReactTooltip
                            id="tooltip_compare_go"
                            place="top"
                            type="dark"
                            effect="solid"
                            multiline={true}
                            afterShow={() => {
                                setTimeout(ReactTooltip.hide, 3000)
                            }}
                        >
                <span>
                    Добавьте товар
                    <br/> к сравнению
                </span>
                        </ReactTooltip>
                    </>
                )}
        </>
    )
}

export default CompareGo
